import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Number$isInteger from "@babel/runtime-corejs3/core-js-stable/number/is-integer";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source), true)).call(_context4, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context5; _forEachInstanceProperty(_context5 = ownKeys(Object(source))).call(_context5, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Using this 3rd party lib to get reg expression from path and match it against location
// path string
//  https://github.com/pillarjs/path-to-regexp
import pathToRegExp from 'path-to-regexp';
import invariant from 'invariant';
import { sortStable, byMatchedIndex } from './sort';
/**
 * Match location object against given route object
 * @param  {Object} location
 * @param  {Object} route
 * @param  {Object} options
 * @return {MatchResult|null}
 */

export function match(location, route) {
  var _context, _context2;

  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  invariant(location && location.path, 'Cannot match! Location path not defined!');
  invariant(route && route.path, 'Cannot match! Route path not defined!');

  var matchOptions = _objectSpread({
    sensitive: true,
    end: false
  }, options); // Match path first


  var pathParams = [];
  var pathMatch = pathToRegExp(route.path, pathParams, matchOptions);
  var pathMatches = pathMatch.exec(location.path);

  if (!pathMatches) {
    return null;
  } else if (matchOptions.exact && pathMatches[0] !== location.path) {
    return null;
  } // Then, if defined, match hash


  var hashParams = [];
  var hashMatches = [];

  if (route.hash) {
    var hashMatch = pathToRegExp(route.hash, hashParams, matchOptions);
    hashMatches = hashMatch.exec(location.hash);

    if (!hashMatches) {
      return null;
    } else if (matchOptions.exact && hashMatches[0] !== location.hash) {
      return null;
    }
  }

  var params = {}; // The first entry of both match arrays is the full string,
  // so them remove this first

  pathMatches.shift();
  hashMatches.shift();

  var allMatches = _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(pathMatches), _toConsumableArray(hashMatches));

  var allParams = _concatInstanceProperty(_context2 = []).call(_context2, pathParams, hashParams);

  _forEachInstanceProperty(allParams).call(allParams, function (param, i) {
    // Only pass on named parameters to avoid confusion
    // So `/some/(.*)/thing` will not pass the match for `.*` through, since it
    // is not named!
    if (!_Number$isInteger(param.name)) {
      params[param.name] = allMatches[i];
    }
  }); // The match index is used for global modals to be able to sort them logically
  // by the appearance of their hash pattern in the actual hash, e.g.
  //  #/foo/bar
  //  #/bar/foo
  // ^ These should show `foo` and `bar` in different order!


  var matchIndex = null;

  if (hashParams && hashParams[0] && hashParams[0].pattern === '.*') {
    // Wildcard param in the beginning of the route
    matchIndex = hashMatches[0].length;
  }

  return {
    hash: route.hash !== undefined ? route.hash : null,
    path: route.path,
    query: location.query || {},
    params: params,
    matchIndex: matchIndex
  };
}
/**
 * Match a (possibly) nested object of routes against given location
 * @param  {Object} location
 * @param  {Object} routes
 * @param  {string} prefix - for internal use when calling function recursively
 * @return {MatchResult[]|null}
 */

export function matchMany(location, routes) {
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  invariant(routes && routes instanceof Object && !_Array$isArray(routes), 'Routes need to be defined as an routes object!');
  var matches = [];

  for (var key in routes) {
    var _context3;

    if (key === 'config') {
      continue;
    }

    var route = routes[key];
    var routePrefix = prefix ? _concatInstanceProperty(_context3 = "".concat(prefix, ".")).call(_context3, key) : key;

    if (!route || !route.config) {
      continue;
    }

    var m = match(location, route.config, {
      exact: route.config.exact
    });

    if (m) {
      matches.push(_objectSpread(_objectSpread({
        key: routePrefix
      }, m), {}, {
        route: route.config
      }));

      if (_Object$keys(route).length > 1) {
        // If the route has other routes as children nested under it,
        // call `matchMany` recursively
        var subMatches = matchMany(location, route, routePrefix);

        if (subMatches) {
          // ... and merge the matches into the final array
          matches = _concatInstanceProperty(matches).call(matches, subMatches);
        }
      }
    }
  } // Bail on matching if we have none


  if (!matches.length) return null; // Sort matches smartly so we can render them according to this arrays sorting
  // This makes sure global modals are rendered according to the pattern of the URL
  // independent of their order in the routes config
  //  #/foo/bar  <== this should return [foo, bar]
  //  #/bar/foo  <== this should return [bar, foo]

  var stableMatches = sortStable(matches, byMatchedIndex); // Return null instead of empty arrays

  return stableMatches.length ? stableMatches : null;
}
/**
 * @typedef {Object} MatchResult
 * @prop {String} hash
 * @prop {String} path
 * @prop {Object} query
 * @prop {Object} params
 * @prop {Number} matchIndex
 */